export const LICENSE_TEST_IDS = {
  agreement: {
    accept: 'license.agreement.button.accept',
    acceptCheckbox: 'license.agreement.checkbox.accept',
    page: 'license.agreement.view.page',
  },
} as const;
